import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

// Components
import AsyncInfoCardPriceSlider from 'app/shared/modules/MobileSRP/ListingCards/InfoCard/InfoCardPriceSlider';
import AsyncInfoCardBedSelector from 'app/shared/modules/MobileSRP/ListingCards/InfoCard/InfoCardBedSelector';

// Hooks
import { useInfoCards } from './hooks';

// Misc / utils
import * as S from './styles';
import type { RootReduxState } from 'app/shared/flux/reducers';

const InfoCard = () => {
  // Redux
  const priceState = useSelector((state: RootReduxState) => state.filter.price);
  const bedState = useSelector((state: RootReduxState) => state.filter.bedrooms);

  // Hooks
  const [getInfoCardType, infoCardDetails, shouldDisplayPriceSlider, shouldDisplayBedSelector] = useInfoCards();

  useEffect(() => {
    // @ts-expect-error useInfoCards hook params don't match Redux state types exactly
    getInfoCardType({ priceState, bedState });
  }, [getInfoCardType, priceState, bedState]);

  const shouldShowInfoCardSkeleton =
    infoCardDetails === null && shouldDisplayPriceSlider === false && shouldDisplayBedSelector === false;

  return (
    <S.InfoCardLi
      aria-label={
        shouldShowInfoCardSkeleton || !infoCardDetails
          ? ''
          : `Want to fine tune these listings? ${infoCardDetails.description}. Else, keep tabbing to return to listings`
      }
      tabIndex={0}
    >
      {shouldShowInfoCardSkeleton ? (
        <S.SkeletonContainer>
          <S.SkeletonCard />
          <S.SkeletonCard />
        </S.SkeletonContainer>
      ) : (
        <>
          {infoCardDetails && (
            <S.FlexHeader>
              <S.InfoCardImg src={infoCardDetails.icon} height="32px" width="32px" alt="" loading="lazy" />
              <section>
                <S.InfoCardTitle>{infoCardDetails.title}</S.InfoCardTitle>
                <S.InfoCardDescription>{infoCardDetails.description}</S.InfoCardDescription>
              </section>
            </S.FlexHeader>
          )}
          <S.InfoCardFilterContainer>
            {shouldDisplayPriceSlider && <AsyncInfoCardPriceSlider />}
            {shouldDisplayBedSelector && <AsyncInfoCardBedSelector />}
          </S.InfoCardFilterContainer>
        </>
      )}
    </S.InfoCardLi>
  );
};

export default InfoCard;
